
import { useState } from 'react';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import { Modal, ModalBody, ModalContent, ModalTrigger } from '@/common-utils/components/ui/modal';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import actionsPosTerminals from '../../../api/actionsPosTerminals';
import useCheckConnectionPoints from '../../../hooks/useCheckConnectionPoints';
import PropTypes from 'prop-types';
import { useToast } from '@/common-utils/hooks/use-toast';
import { nsTerminal } from '@/app/i18n/namespaces';

/**
 * @param {JSX.Element} trigger element that triggers modal opening
 * @returns {JSX.Element} ModalUnblacklistPosTerminal Component
 */
function ModalUnblacklistPosTerminal({ trigger, isOpen, setIsOpen, subscriptionId, setLaunchRefetch }) {

    // Toast
    const { toast } = useToast();

    // State
    const [bodyContent, setBodyContent] = useState(<></>);

    // API Calls
    // Queries
    const getConnectionPointsResponse = actionsPosTerminals.getConnectionPoints(subscriptionId);

    // Mutations
    const onSuccess = () => {
        setLaunchRefetch(true);
        setIsOpen(false);
        toast({
            description: <Entity entity={'modal.unblacklist.success'} namespace={nsTerminal} />,
            variant: 'success'
        });
    };
    const onError = () => {
        setIsOpen(false);
        toast({
            description: <Entity entity={'modal.unblacklist.error'} namespace={nsTerminal} />,
            variant: 'danger'
        });
    };
    const submitUnblacklistPosTerminal = actionsPosTerminals.unblacklistPosTerminal(onSuccess, onError);

    // Hooks
    useCheckConnectionPoints(getConnectionPointsResponse, setBodyContent, 'modal.unblacklist');

    // Renders
    const content =
        <ModalContent className={cn('max-w-lg')}>
            <HeaderTitle title={'modal.unblacklist.title'} namespace={nsTerminal} />
            <ModalBody>
                {bodyContent}
            </ModalBody>
            <FooterForm
                onSubmit={() => submitUnblacklistPosTerminal.mutate({ subscriptionId })}
                isSubmitting={submitUnblacklistPosTerminal.isLoading}
                isSubmitDisabled={getConnectionPointsResponse.isLoading}
                showSubmitButton={getConnectionPointsResponse.data}
            />
        </ModalContent>;

    if (trigger) {
        return (
            <Modal>
                <ModalTrigger>{trigger}</ModalTrigger>
                {content}
            </Modal>
        );
    }

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            {content}
        </Modal>
    );
}

ModalUnblacklistPosTerminal.propTypes = {
    trigger: PropTypes.element,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    subscriptionId: PropTypes.string,
    setLaunchRefetch: PropTypes.func
};

export default ModalUnblacklistPosTerminal;